<template>
  <div class="apply-new-user">
    <Card shadow class="content">
      <div class="main">
        <Row class="title">
          <h4 :style="{float: 'left'}">申请新用户</h4>
        </Row>
        <GeneralAlert></GeneralAlert>
        <Form inline :label-width="70" :rules="baseInfoFormRules" ref="baseInfo" :model="baseInfo">
          <FormItem label="实例" style="width: 100%" prop="instance">
            <Select v-model="baseInfo.instance" placeholder="请选择数据库实例" filterable transfer @on-change="getDatabases" clearable ref="execInstance" label-in-value>
              <OptionGroup label="MySQL">
                <Option v-for="item in instanceList.mysql" :value="'mysql_' + item.id" :key="'mysql_' + item.id">{{ item.name }}</Option>
              </OptionGroup>
              <!--<OptionGroup label="MongoDB">-->
              <!--<Option v-for="item in instanceList.mongodb" :value="'mongodb_' + item.id" :key="'mongodb_' + item.id">{{ item.name }}</Option>-->
              <!--</OptionGroup>-->
              <OptionGroup label="SQL Server">
                <Option v-for="item in instanceList.sqlserver" :value="'sqlserver_' + item.id" :key="'sqlserver_' + item.id">{{ item.name }}</Option>
              </OptionGroup>
            </Select>
          </FormItem>
          <FormItem label="数据库" style="width: 100%" prop="database_name">
            <Select v-model="baseInfo.database_name" placeholder="请选择数据库" filterable transfer multiple @on-change="getTables" clearable ref="execDatabase">
              <Option v-for="item in databaseList" :value="item" :key="item">{{ item }}</Option>
            </Select>
          </FormItem>
          <FormItem label="数据表" style="width: 100%" prop="table_name">
            <Select v-model="baseInfo.table_name" placeholder="请选择数据表，默认赋权所有表" filterable transfer multiple clearable ref="execTable">
              <Option v-for="item in tableList" :value="item" :key="item">{{ item }}</Option>
            </Select>
          </FormItem>
          <FormItem label="申请权限" style="width: 100%" prop="privileges">
            <Select v-model="baseInfo.privileges" placeholder="请选择要申请的权限" filterable transfer multiple @on-change="privilegesChange">
              <Option v-for="item in privilegeList" :value="item.value" :key="item.value" :disabled="baseInfo.privileges.indexOf('ALL') > -1 && item.value !== 'ALL'">{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem label="IP 网段" style="width: 100%" prop="ip_segment">
            <Select v-model="baseInfo.ip_segment" placeholder="请选择IP网段" filterable transfer>
              <Option v-for="item in ipSegList" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem label="用户名" style="width: 100%" prop="username">
            <Input :maxlength="50" v-model="baseInfo.username" placeholder="用户名" />
          </FormItem>
          <FormItem label="密码" style="width: 100%" prop="password">
            <Input :maxlength="50" v-model="baseInfo.password" placeholder="" type="password" />
          </FormItem>
          <FormItem label="确认密码" style="width: 100%" prop="password2">
            <Input :maxlength="50" v-model="baseInfo.password2" placeholder="" type="password" />
          </FormItem>
          <FormItem label="申请说明" style="width: 100%">
            <Input type="textarea" :maxlength="2048" v-model="baseInfo.application_content" :rows="6" placeholder="申请说明" />
          </FormItem>
        </Form>
        <div style="text-align: center;">
          <Button type="primary" style="margin-right: 10px" :loading="submitting" @click="submit">提交申请</Button>
          <Button @click="$router.go(-1)">取消</Button>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
import { dbReleaseFlowApplyNewUser } from '@/api/workflow/db_release_flow'
import { getAllInstance } from '@/api/database'
import { showDatabaseList as showMysqlDatabaseList,
  showTableList as showMysqlTableList } from '@/api/mysql'
import { showDatabaseList as showSqlServerDatabaseList,
  showTableList as showSqlServerTableList } from '@/api/sqlserver'
import GeneralAlert from '../components/general-alert'

export default {
  name: 'apply-privilege',
  components: {
    GeneralAlert
  },
  data () {
    return {
      instanceList: {
        mysql: [],
        mongodb: [],
        sqlserver: []
      },
      baseInfo: {
        instance: '',
        instance_name: '',
        application_content: '',
        privileges: [],
        table_name: [],
        database_name: [],
        ip_segment: '',
        username: '',
        password: '',
        password2: ''
      },
      databaseList: [],
      tableList: [],
      privilegeList: [
        { value: 'ALL', label: 'all' },
        { value: 'INSERT', label: 'insert' },
        { value: 'DELETE', label: 'delete' },
        { value: 'UPDATE', label: 'update' },
        { value: 'SELECT', label: 'select' },
        { value: 'CREATE', label: 'create' },
        { value: 'INDEX', label: 'index' },
        { value: 'ALTER', label: 'alter' },
        { value: 'EVENT', label: 'event' },
        { value: 'EXECUTE', label: 'execute' },
        { value: 'CREATE VIEW', label: 'create view' },
        { value: 'CREATE ROUTINE', label: 'create routine' },
        { value: 'ALTER ROUTINE', label: 'alter routine' }
      ],
      ipSegList: [
        { value: '10.7.%', label: '10.7.%' },
        { value: '172.16.%', label: '172.16.%' },
        { value: '10.%', label: '10.%' },
        { value: '%', label: '%' }
      ],
      baseInfoFormRules: {
        instance: { required: true, message: '请选择实例！', trigger: 'change' },
        privileges: { required: true, message: '请选择要申请的权限！', type: 'array' },
        database_name: { required: true, message: '请选择要数据库！', type: 'array' },
        ip_segment: { required: true, message: '请选择IP网段！', trigger: 'change' },
        username: { required: true, message: '用户名不能为空！', trigger: 'blur' },
        password: [
          { required: true, message: '密码不能为空！', trigger: 'blur' },
          { type: 'string', min: 8, message: '密码长度不能小于 8 位', trigger: 'blur' },
          {
            pattern: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$/,
            message: '密码必须包含至少一位大写，小写，数字，特殊字符',
            trigger: 'blur'
          }
        ],
        password2: { required: true, message: '', trigger: 'blur', validator: this.validPasswordRule }
      },
      submitting: false
    }
  },
  mounted: function () {
    this.getInstances()
  },
  watch: {
    '$store.state.user.defaultTenant' () {
      this.getInstances()
    }
  },
  methods: {
    submit () {
      this.$refs.baseInfo.validate((valid) => {
        if (valid) {
          this.baseInfo.instance_id = this.baseInfo.instance.split('_')[1]
          this.baseInfo.instance_type = this.baseInfo.instance.split('_')[0]
          this.submitting = true
          dbReleaseFlowApplyNewUser(this.baseInfo).then(res => {
            this.$Notice.success({ title: '操作成功' })
            this.$router.push({ name: 'dbReleaseFlowDetail', params: { id: res.data.id } })
            this.submitting = false
          }).catch(res => {
            this.submitting = false
            console.log(res.response)
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！'
              })
            }
          })
        } else {
          this.$Notice.warning({ title: '请检查表单！' })
        }
      })
    },
    // 获取实例列表
    getInstances () {
      this.$refs.execInstance.clearSingleSelect()
      getAllInstance({ tenant_id__in: this.$store.state.user.defaultTenant }).then(res => {
        this.instanceList = res.data
      })
    },
    // 获取数据表
    getTables (database) {
      this.$refs.execTable.clearSingleSelect()
      this.tableList = []
      if (!database.length) {
        return
      }
      for (let i in database) {
        if (this.baseInfo.instance.split('_')[0] === 'mysql') {
          showMysqlTableList({ id: this.baseInfo.instance.split('_')[1], db: database[i] }).then(res => {
            let data = res.data.results
            for (let t in data) {
              data[t] = database[i] + '.' + data[t]
            }
            this.tableList = this.tableList.concat(data)
          })
        } else if (this.baseInfo.instance.split('_')[0] === 'sqlserver') {
          showSqlServerTableList({ id: this.baseInfo.instance.split('_')[1], db: database[i] }).then(res => {
            let data = res.data.results
            for (let t in data) {
              data[t] = database[i] + '.' + data[t]
            }
            this.tableList = this.tableList.concat(data)
          })
        }
      }
    },
    // 获取数据库
    getDatabases (instanceObj) {
      let instance = instanceObj.value
      this.baseInfo.instance_name = instanceObj.label
      this.$refs.execDatabase.clearSingleSelect()
      this.databaseList = []
      if (!instance) {
        return
      }
      let instanceId = instance.split('_')[1]
      let instanceType = instance.split('_')[0]
      if (instanceType === 'mysql') {
        showMysqlDatabaseList({ id: instanceId }).then(res => {
          this.databaseList = res.data.results
        })
      } else if (instanceType === 'sqlserver') {
        showSqlServerDatabaseList({ id: instanceId }).then(res => {
          this.databaseList = res.data.results
        })
      }
    },
    // 选择申请权限触发
    privilegesChange (ps) {
      if (ps.indexOf('ALL') > -1) {
        this.baseInfo.privileges = ['ALL']
      }
    },
    // 二次确认密码规则
    validPasswordRule (rule, value, callback) {
      if (!this.baseInfo.password2) {
        callback(new Error('确认密码不能为空！'))
      } else if (this.baseInfo.password !== this.baseInfo.password2) {
        callback(new Error('两次输入的密码不同！'))
      } else {
        callback()
      }
    }
  }
}
</script>

<style lang="less">
  @import '../../base.less';
</style>
